// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__nqBu4","centerColumn":"Layout_centerColumn__vAJwH"};